<template>
  <div class="subscription-container">
    <div class="sub-header-wrapper">
      <span> Subscription </span>
    </div>
    <div class="membership-type">
      <span class="membership-type-text">
        Membership Type:
        <font style="font-weight: 700; text-transform: capitalize">
          {{ membershipType }}
        </font>
      </span>
    </div>
    <div class="sub-info-container">
      <div class="sub-status">
        <span class="sub-status-text">
          Status:
          <font style="font-weight: 700; text-transform: capitalize">
            {{ subStatus }}
          </font>
        </span>
      </div>
      <div class="invoice-status">
        <span class="invoice-status-text">
          Next invoice date:
          <font style="font-weight: 700">
            {{ readableDate }}
          </font>
        </span>
      </div>
      <div class="phone-number">
        <div class="phone-number-wrapper">
          <span class="phone-number-text">
            Phone Number:
            <font style="font-weight: 700">
              {{ formattedPhoneNumber }}
            </font>
          </span>
        </div>
        <div class="edit-icon" @click="togglePhoneNumberModal">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="ff"
            stroke="#ffffff"
            fill-opacity="0.0"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-edit"
          >
            <path
              d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"
            ></path>
            <polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon>
          </svg>
        </div>
      </div>
      <div class="trading-view">
        <div class="trading-view-wrapper">
          <span class="trading-view-text">
            Trading View:
            <font style="font-weight: 700">
              {{ formattedTradingView }}
            </font>
          </span>
        </div>
        <div class="edit-icon" @click="toggleTradingViewModal">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="ff"
            stroke="#ffffff"
            fill-opacity="0.0"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-edit"
          >
            <path
              d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"
            ></path>
            <polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon>
          </svg>
        </div>
      </div>
      <div>
        <h6><strong>Alert</strong></h6>
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="selected"
            :options="options"
            :aria-describedby="ariaDescribedby"
            name="flavour-1"
          ></b-form-checkbox-group>
        </b-form-group>
      </div>
      <div class="discord-link">
        <button @click="getDiscordInvite">
          <span class="discord-link-text"> Get Discord Invite </span>
        </button>
      </div>
    </div>
    <PhoneNumberModal
      v-show="isPhoneNumberModalVisible"
      @update="updateNumberOnFile"
      @unsubscribe="removeNumberOnFile"
      @close="togglePhoneNumberModal"
    />
    <TradingViewModal
      v-show="isTradingViewModalVisible"
      @newUsername="updateUsernameOnFile"
      @close="toggleTradingViewModal"
      :discord="discord"
    />
  </div>
</template>

<script scoped>
import db from "../../database/index";
const collection = db.collection("users");

import PhoneNumberModal from "@/components/PhoneNumberModal";
import TradingViewModal from "@/components/TradingViewModal";

export default {
  name: "Subscription",
  props: {
    user: {
      type: Object,
    },
    discord: {
      type: Object,
    },
  },
  components: {
    PhoneNumberModal,
    TradingViewModal,
  },
  data() {
    return {
      phoneNumber: this.user.phoneNumber,
      tradingView: this.user.tradingView,
      membershipType: this.user.type,
      subStatus: this.user.status,
      isPhoneNumberModalVisible: false,
      isTradingViewModalVisible: false,
      selected: [], // Must be an array reference!
      options: [
        { text: "Email", value: "email" },
        { text: "Text", value: "text" },
      ],
    };
  },
  mounted() {
    console.log("this.user:==> ", this.discord.id);
    console.log("this.phoneNumber:==>", this.user);
    if (this.user.phoneNumber != "") {
      this.selected.push("text");
    }

    if ("is_text" in this.user) {
      if (this.user.is_text) {
        this.selected.push("text");
      }
    }

    if ("is_email" in this.user) {
      if (this.user.is_email) {
        this.selected.push("email");
      }
    }
  },
  methods: {
    convertUnix() {
      let date = new Date(this.user.nextPayment * 1000);
      const month = date.toLocaleString("en-US", { month: "long" });
      const day = date.toLocaleString("en-US", { day: "numeric" });
      const year = date.toLocaleString("en-US", { year: "numeric" });
      return month + " " + day + ", " + year;
    },
    formatNumber() {
      let phone = this.phoneNumber;

      // If no number on file
      if (phone.length === 0) {
        return "No number on file";
      }

      // If number is in E.164 format
      if (phone.includes("+")) {
        phone = phone.substring(2);
      }

      return (
        "(" +
        phone.substring(0, 3) +
        ") " +
        phone.substring(3, 6) +
        "-" +
        phone.substring(6, 11)
      );
    },
    formatTradingView() {
      let tradingView = this.tradingView;

      // if no username on file
      if (tradingView.length === 0) {
        return "No username on file";
      }

      return tradingView;
    },
    getDiscordInvite() {
      window.open("https://discord.gg/aUNMrjg");
    },
    hasPhoneNumber() {
      this.user.phoneNumber.length;
    },
    togglePhoneNumberModal() {
      this.isPhoneNumberModalVisible = !this.isPhoneNumberModalVisible;
    },
    toggleTradingViewModal() {
      this.isTradingViewModalVisible = !this.isTradingViewModalVisible;
    },
    async updateNumberOnFile(e) {
      // Toggle modal
      this.isPhoneNumberModalVisible = !this.isPhoneNumberModalVisible;

      // Update phone number in firebase
      await collection
        .where("discordId", "==", this.discord.id)
        .get()
        .then((snap) =>
          snap.forEach(async (doc) => {
            await collection.doc(doc.id).update({ phoneNumber: e.phoneNumber });
          })
        );

      // Update local data
      this.phoneNumber = e.phoneNumber;
    },
    async removeNumberOnFile() {
      // Toggle modal
      this.isPhoneNumberModalVisible = !this.isPhoneNumberModalVisible;

      // Remove phone number in firebase
      await collection
        .where("discordId", "==", this.discord.id)
        .get()
        .then((snap) =>
          snap.forEach(async (doc) => {
            await collection.doc(doc.id).update({ phoneNumber: "" });
          })
        );

      // Update local data
      this.phoneNumber = "";
    },
    async updateUsernameOnFile(e) {
      this.isTradingViewModalVisible = !this.isTradingViewModalVisible;

      this.tradingView = e;
    },
    async update_flag() {
      console.log("Updated Flag");
      let data = {
        is_text: true,
        is_email: true,
      };

      if (this.selected.includes("email")) {
        data.is_email = true;
      } else {
        data.is_email = false;
      }

      if (this.selected.includes("text")) {
        data.is_text = true;
      } else {
        data.is_text = false;
      }

      await collection
        .where("discordId", "==", this.discord.id)
        .get()
        .then((snap) =>
          snap.forEach(async (doc) => {
            await collection.doc(doc.id).update(data);
          })
        );
    },
  },
  computed: {
    readableDate: function () {
      return this.convertUnix();
    },
    formattedPhoneNumber: function () {
      return this.formatNumber();
    },
    updateStatus: function () {
      return this.user.status;
    },
    formattedTradingView: function () {
      return this.formatTradingView();
    },
  },
  watch: {
    updateStatus() {
      this.subStatus = this.user.status;
    },
    selected: function () {
      this.update_flag();
      return;
    },
  },
};
</script>

<style>
.subscription-container {
  height: 300px;
  width: 400px;
  background-color: #36393f;
  color: #f8f8f8;
  font-size: 14px;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 1px 1px 0px #282b2f, 2px 2px 0px #2f3033, 3px 3px 0px #282b2f,
    4px 4px 0px #2f3033, 5px 5px 0px #282b2f, 6px 6px 0px #2f3033;
}

.sub-header-wrapper {
  padding-top: 8px;
  padding-bottom: 10px;
  font-weight: 800;
  font-size: 1.3em;
  text-transform: uppercase;
}

.sub-info-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.phone-number {
  margin-top: 20px;
}

.update-number {
  margin-top: 8px;
}

.update-number button {
  background-color: #7289da;
  border: #7289da;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
}

.update-number button:hover {
  background-color: #818fc0;
}

.update-number button:active {
  position: relative;
  top: 1px;
}

.update-number button:focus {
  outline: 0;
}

.discord-link {
  margin-top: 6px;
}

.discord-link button {
  background-color: #7289da;
  border: #7289da;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
}

.discord-link button:hover {
  background-color: #818fc0;
}

.discord-link button:active {
  position: relative;
  top: 1px;
}

.discord-link button:focus {
  outline: 0;
}

.edit-icon {
  height: 18px;
  width: 18px;
}

.edit-icon svg:hover {
  stroke: #78d39b;
}

.phone-number {
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-number-wrapper {
  min-width: 280px;
}

.trading-view {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.trading-view-wrapper {
  min-width: 280px;
}
</style>